import { ProductThemeContext, useWindowWidth } from '@prishapolicy/shared/ui';
import { useContext, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

/* eslint-disable-next-line */
export interface NewCustomBackgroundComponentProps {
  backgroundColor?: string;
  children?: any;
  InsuranceForDoctorsFormRender?: () => JSX.Element;
}

export const NewCustomBackgroundComponent = ({ ...props }: NewCustomBackgroundComponentProps) => {
  const formDiv = useRef(null as null | HTMLDivElement);

  const productThemeContext = useContext(ProductThemeContext);
  const { width } = useWindowWidth(0);

  return (
    <div className="relative flex justify-center">
      <div
        className={twMerge(
          `relative mx-3 w-full rounded-b-[20px] bg-${props.backgroundColor || productThemeContext?.primaryShade}`,
        )}
      >
        <div className={twMerge(`relative ${width >= 640 && `container`} `)}>
          <div>{props.children}</div>
          {width >= 1280 && (
            <div
              ref={formDiv}
              className="w-full rounded-lg bg-white shadow-lg lg:absolute lg:top-1 lg:right-16 lg:w-[36%]"
            >
              {props.InsuranceForDoctorsFormRender && <props.InsuranceForDoctorsFormRender />}
            </div>
          )}
        </div>
      </div>

      {width < 1280 && (
        <div
          className="absolute right-0 bottom-[-60%] z-10 mx-4 rounded-lg bg-white shadow-lg lg:bottom-[-56%]"
          style={{ width: 'calc(100% - 2rem)', transform: 'translateY(30%)' }}
        >
          {props.InsuranceForDoctorsFormRender && <props.InsuranceForDoctorsFormRender />}
        </div>
      )}
    </div>
  );
};
